var React = require('react');

function Budget (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"entity-types-images/time-copy","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","fontFamily":"RobotoCondensed-Regular, Roboto Condensed","fontSize":"22","fontStyle":"condensed","fontWeight":"normal","letterSpacing":"-0.141935483"},React.createElement("text",{"id":"1-Lakh","fill":"#333333"},[React.createElement("tspan",{"x":"22.140792","y":"22","key":0},"1"),React.createElement("tspan",{"x":"7.01922253","y":"47","key":1},"Lakh")])));
}

Budget.defaultProps = {"width":"54px","height":"54px","viewBox":"0 0 54 54","version":"1.1"};

module.exports = Budget;

Budget.default = Budget;
